// extracted by mini-css-extract-plugin
module.exports = {"patterMapInfo":"PatterMapInfo_patterMapInfo__2atKU","items":"PatterMapInfo_items__1M0in"};